module.exports = __webpack_public_path__ + "img/harvelles-revival-7.28.4badc3f0.jpg";